import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Job} from "../shared/job.model";
import {Events, ModalController} from "ionic-angular";
import {RatingModal} from "../../../app/components/rating-modal/rating-modal.component";

@Component({
  selector: 'app-client-job-details',
  templateUrl: 'client-job-details.component.html',

})
export class ClientJobDetailsComponent implements OnInit, OnDestroy{
  @Input('job') job: Job;
  stars = [1, 2, 3, 4, 5];

  constructor(
    private modalCtrl: ModalController,
    private events: Events
  ){
  }


  ngOnInit(){
    this.events.subscribe('job:finished', (place) => this.openRatingModal());
  }

  ngOnDestroy(){
    this.events.unsubscribe('job:finished');
  }

  openRatingModal() {
    let modal = this.modalCtrl.create(RatingModal, {
      job: this.job
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/client-job-details/client-job-details.component.ts